import {post} from '@/utils/request';
import {erpserver,oaserver} from '@/utils/baseUrl';

//获取交易公司
export async function getCompanyList(params) {
    return post(oaserver+'/oacurrency/getCompanyList', params, true);
}
//查询列表接口
export async function listInvoice(params) {
    return post(erpserver+'/sellinvoice/listInvoice',params,true)
}
//查询列表接口
export async function listBeforeInvoice(params) {
    return post(erpserver+'/sellinvoice/listBeforeInvoice',params,true)
}
//查询列表接口
export async function listAfterInvoice(params) {
    return post(erpserver+'/sellinvoice/listAfterInvoice',params,true)
}
//保存／删除接口
export async function saveInvoice(params) {
    return post(erpserver+'/sellinvoice/saveInvoice',params,true)
}
//提交
export async function submit(params) {
    return post(erpserver+'/sellinvoice/submit',params,true)
}
//删除提交
export async function cancelsubmit(params) {
    return post(erpserver+'/sellinvoice/cancelsubmit',params,true)
}
//转入待开票列表
export async function reset(params) {
    return post(erpserver+'/sellinvoice/reset',params,true)
}
